import { DeesElement, property, html, customElement, TemplateResult } from '@designestate/dees-element';
import * as domtools from '@designestate/dees-domtools';

import * as sioInterfaces from '@social.io_private/interfaces';

@customElement('sio-subwidget-conversations')
export class SioSubwidgetConversations extends DeesElement {
  // STATIC

  // INSTANCE
  public conversations: sioInterfaces.ISioConversation[] = [
    {
      subject: 'Pricing page',
      parties: [
        {
          id: '1',
          description: 'Lossless Support',
          name: 'Lossless Support',
        },
        {
          id: '2',
          description: 'you',
          name: 'you',
        },
      ],
      conversationBlocks: [
        {
          partyId: '1',
          text: 'Hello there :) How can we help you?',
        },
        {
          partyId: '2',
          text: 'Hi! Where is your pricing page?',
        },
      ],
    },{
      subject: 'Pricing page',
      parties: [
        {
          id: '1',
          description: 'Lossless Support',
          name: 'Lossless Support',
        },
        {
          id: '2',
          description: 'you',
          name: 'you',
        },
      ],
      conversationBlocks: [
        {
          partyId: '1',
          text: 'Hello there :) How can we help you?',
        },
        {
          partyId: '2',
          text: 'Hi! Where is your pricing page?',
        },
      ],
    },
  ];

  public static demo = () => html`<sio-subwidget-conversations></sio-subwidget-conversations>`;
  public render(): TemplateResult {
    return html`
      ${domtools.elementBasic.styles}
      <style>
        :host {
          color: ${this.goBright ? '#666' : '#ccc'};
        }

        .conversationbox {
          padding: 20px;
          transition: all 0.1s;
          min-height: 200px;
          margin: 20px;
          background: ${this.goBright ? '#fff' : '#333'};
          border-radius: 3px;
          border-top: 1px solid rgba(250, 250, 250, 0.2);
          box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.3);
          margin-bottom: 20px;
        }

        .conversationbox:hover {
          border-top: 1px solid #e4002b;
        }

        .conversationbox .text {
          font-family: Roboto;
        }

        .conversation {
          transition: all 0.1s;
          padding: 8px 0px 8px 0px;
          border-bottom: 1px dotted ${this.goBright ? '#CCCCCC' : '#666666'};
          cursor: pointer;
        }

        .conversation:hover {
          background: ${this.goBright ? 'rgba(0,0,0,0.02)' : 'rgba(255,255,255,0.03)'};
          padding: 8px 0px 8px 0px;
          border-bottom: 1px dotted ${this.goBright ? '#CCCCCC' : '#666666'};
          cursor: pointer;
        }

        .conversation .gridcontainer {
          display: grid;
          grid-template-columns: 50px auto;
        }

        .conversation .gridcontainer .profilePicture {
          height: 40px;
          width: 40px;
          border-radius: 50px;
          background: ${this.goBright ? '#EEE' : '#444'};
        }

        .conversation .gridcontainer .text .topLine {
          font-family: Roboto Mono;
          font-size: 12px;
        }

        .gridcontainer .gridcontainer .text .bottomLine {
          font-family: Roboto Mono;
          font-size: 15px;
        }
      </style>
      <div class="conversationbox">
        <div class="text">Your conversations:</div>

        ${this.conversations.map((conversationArg) => {
          return html`
            <div class="conversation">
              <div class="gridcontainer">
                <div class="profilePicture"></div>
                <div class="text">
                  <div class="topLine">Today at 8:01</div>
                  <div class="bottomLine">${conversationArg.subject}</div>
                </div>
              </div>
            </div>
          `;
        })}
        <dees-button>View more</dees-button>
      </div>
    `;
  }
}
